import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCreateEmailMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ISendEmailResponse) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			email,
			contentCalendarSuggestionId,
			additionalAttachments,
			impersonationContext,
		}: {
			email: Api.IEmailMessageCompose<Api.IFollowUpOptions>;
			contentCalendarSuggestionId?: string;
			additionalAttachments?: File[];
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			const formData = new FormData();
			formData.append('value', JSON.stringify(email));

			if (additionalAttachments?.length) {
				additionalAttachments.forEach(x => formData.append('files', x));
			}

			return userSession.webServiceHelper.callAsync<Api.ISendEmailResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { contentCalendarSuggestionId },
					urlPath: `email`,
				}),
				'POST',
				formData
			);
		},
		onError,
		onSuccess,
	});
};
